export default {"src":"/_next/static/media/compliance-solutions.0b9c9ea4.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};